<style>
	.tips-mask{
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 50;
		background-color: rgba(255,255,255,.0);
	}
	.tips-mask .tips-wrapper{
		position: absolute;
		top: 50%;
		width: 70%;
		margin: 0 15%;
		margin-top: -90px;
		border-radius: 8px;
		background-color: rgba(255,255,255,.8);
		box-shadow: 0px 5px 10px rgba(0,0,0,.1);
	}
	.tips-mask .tips-wrapper .tips-font{
		margin: 0;
		text-align: center;
		height: 80px;
		border-bottom: solid 1px #b2b2b2;
		box-sizing: border-box;
		padding: 10px;
		vertical-align: middle;
	}
	.tips-mask .tips-wrapper .tips-font p{
		height: auto;
		vertical-align: middle;
		font-size: .9em
	}
	.tips-mask .tips-wrapper .tips-btns{
		height: 40px;
		margin: 0;
		padding: 0;
		text-align: center;
	}
	.tips-mask .tips-wrapper .tips-btns .tips-two-btn{
		float: left;
		width: 50%;
		height: 40px;
		line-height: 40px;
		box-sizing: border-box;
		color:#26a1a4;
	}
	.tips-mask .tips-wrapper .tips-btns .tips-one-btn{
		display: block;
		height: 40px;
		line-height: 40px;
		box-sizing: border-box;
		color:#26a1a4;
	}
	.tips-mask .tips-wrapper .tips-btns .tips-btn-line{
		border-right: solid 1px #b2b2b2;
	}
</style>

<template>
	<div class="tips-mask">
		<div class="tips-wrapper">
			<div v-if="!tipsFontWaring" class="tips-font"><p>{{tipsFont}}</p></div>
			<div v-if="tipsFontWaring" class="tips-font red-font"><p>{{tipsFont}}</p></div>
			<div class="tips-btns" v-if="btnNum === 1">
				<a class="tips-one-btn" @click="onConfirmF">确定</a>
			</div>
			<div class="tips-btns" v-if="btnNum === 2">
				<a class="tips-two-btn tips-btn-line" @click="onCancel">取消</a>
				<a class="tips-two-btn" @click="onConfirmS">确定</a>
			</div>
			<div class="tips-btns" v-if="btnNum === 3">
				<a class="tips-two-btn tips-btn-line" @click="onCancel">{{btnFont[0]}}</a>
				<a class="tips-two-btn" @click="onConfirmS">{{btnFont[1]}}</a>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		btnNum: Number,
		tipsFont: String,
		tipsFontWaring: {
			type: Boolean,
			default: () => {
				return false
			}
		},
		btnFont: {
			type: Array,
			default: () => {
				return ['否', '是']
			}
		}
	},
	data () {
		return {
			tipsShow: true
		}
	},
	methods: {
		tipStatus (flag) {
			this.tipsShow = false
			var msg = [this.tipsShow, flag]
			this.$emit('tipStatus', msg)
		},
		onConfirmS () {
			this.tipStatus(true)
		},
		onConfirmF () {
			this.tipStatus(false)
		},
		onCancel () {
			this.tipStatus(false)
		}
	}
}
</script>



// WEBPACK FOOTER //
// Tips.vue?2e3673a0